import { TrackedLink } from "lib/analytics/react/link";
import { TYPO } from "styles/Typo";

interface Props {
  editHandler: () => void;
}

function InterestEditButton({ editHandler }: Props) {
  return (
    <TrackedLink
      itemspec={{
        kind: "section_nav",
        section_id: "watchlist_stock_list",
        nav_key: "watchlist_navbtn_edit_stock",
      }}
      href="/watchlist/edit"
      className="px-1 py-[2px] gap-[2px] bg-grayOpacity10 rounded-[6px] flex items-center cursor-pointer"
      // onClick={editHandler}
      data-gtm-id={`watchlist-edit-btn`}
      asTrace={true}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M2.45052 12.2345C2.24635 12.2831 2.06892 12.2321 1.91822 12.0814C1.76753 11.9307 1.71649 11.7533 1.7651 11.5491L2.27552 9.06992L4.92968 11.7241L2.45052 12.2345ZM5.8776 11.0095L2.9901 8.12201L9.01302 2.09909C9.23663 1.87548 9.51371 1.76367 9.84427 1.76367C10.1748 1.76367 10.4519 1.87548 10.6755 2.09909L11.9005 3.32409C12.1241 3.5477 12.2359 3.82478 12.2359 4.15534C12.2359 4.48589 12.1241 4.76298 11.9005 4.98659L5.8776 11.0095Z"
          fill="#4E5968"
        />
      </svg>
      <p className={`${TYPO.TYPO8_MD} text-gray70`}>편집</p>
    </TrackedLink>
  );
}

export default InterestEditButton;
